<template>
  <div class="pagination">
    <el-pagination  @size-change="sizeChange" @current-change="currentChange" :current-page="pageNum"
      layout="prev, pager, next" :total="total">
    </el-pagination>
  </div>
</template>

<script>
export default {
  name: 'pagination',
  props: {
    pageNum: {
      type: Number,
      default: 1
    },
    total: {
      type: Number,
      default: 100
    }
  },
  data () {
    return {
    }
  },
  methods: {
    sizeChange (val) {
      this.$emit('sizeChange', val)
    },
    currentChange (val) {
      this.$emit('currentChange', val)
    }
  },
  mounted () {
  }
}
</script>

<style lang='scss' rel='stylesheet/scss' scoped>
.pagination {
  text-align: center;
  background-color: #fff;
  border-radius: 0 0 4px 4px;
  padding: 28px !important;

}
.pagination /deep/ .el-pagination {
  font-weight: 400;
}
.pagination /deep/ .el-pagination.is-background .el-pager li {
  // background-color: #fff;
  border: 1px solid #dcdfe6;
  
}
.pagination
  /deep/
  .el-pagination.is-background
  .el-pager
  li:not(.disabled).active {
  background-color: #4F7AFD;
  border: 1px solid #4F7AFD;
}
.pagination /deep/ .el-pagination.is-background .btn-next {
  background-color: #fff;
  border: 1px solid #dcdfe6;
}
.pagination /deep/ .el-pagination.is-background .btn-prev {
  background-color: #fff;
  border: 1px solid #dcdfe6;
}
.pagination /deep/ .el-pagination.is-background .el-icon {
  font-weight: 400;
  font-size: 16px;
}
.pagination /deep/ .el-pagination.is-background .el-pagination__jump .el-input__inner{
  border: none;
  &:focus{
    box-shadow: none;
  }
}
@media screen and(max-width:1440px){
   .pagination /deep/ .el-pagination {
        font-weight: 400;
      }
}
</style>
